import { theme } from '@zappyrent/hundop';
import { rem } from 'polished';
import styled from 'styled-components/macro';

import { IHeroBannerStyledWrapperProps } from './HeroBanner.types';

export const StyledIconWrapper = styled.span`
  margin-left: ${rem('16px')};

  svg {
    width: ${rem('88px')};
  }

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.l}) {
    display: none;
  }
`;

export const StyledParagraph = styled.p`
  margin: 0;
  font-size: ${rem('18px')};
  font-weight: 500;
  margin-top: ${rem('8px')};
  line-height: 1.6;
`;

export const StyledWrapper = styled.section<IHeroBannerStyledWrapperProps>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: ${rem('32px')};
  color: ${({ color }) => (color ? color : theme.colors.main)};
  background-color: ${({ backgroundColor }) =>
    backgroundColor ? backgroundColor : theme.colors.mainAlternate};
  border-radius: ${rem('16px')};

  ${StyledIconWrapper} {
    svg path {
      fill: ${({ color }) => (color ? color : theme.colors.main)};
    }
  }
`;
